import EmailIcon from '@/assets/images/icons/EmailIcon.svg'
import PhoneIcon from '@/assets/images/icons/PhoneIcon.svg'
import LocationIcon from '@/assets/images/icons/LocationIcon.svg'
import { Base, UserIcon } from '@itsrever/design-system'
import { useCountries } from '@/application/queries'
import { Customer } from '@/domain/customer'
import { useTranslation } from 'react-i18next'

const { Card } = Base

interface CustomerInformationProps {
  customer: Customer
}

const CustomerInformation: React.FC<CustomerInformationProps> = ({
  customer
}) => {
  const { t } = useTranslation()

  const { countries } = useCountries()

  const country =
    countries?.find((c) => c.iso === customer.address.countryCode)?.name ?? ''

  return (
    <Card className="h-fit p-4">
      <div className="mb-3 flex items-center gap-1.5">
        <UserIcon className="size-5 text-primary-main" />
        <p className="text-sm font-semibold">
          {t('summary.customer_information')}
        </p>
      </div>
      <div className="w-full">
        <div className="mt-2 flex flex-col gap-1.5 text-neutral-700">
          <div className="flex items-center gap-1.5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="currentColor"
              viewBox="0 0 256 256"
              className="size-4.5 ml-[0.1rem] text-black"
            >
              <path d="M200,112a8,8,0,0,1-8,8H152a8,8,0,0,1,0-16h40A8,8,0,0,1,200,112Zm-8,24H152a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm40-80V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Zm-80.26-34a8,8,0,1,1-15.5,4c-2.63-10.26-13.06-18-24.25-18s-21.61,7.74-24.25,18a8,8,0,1,1-15.5-4,39.84,39.84,0,0,1,17.19-23.34,32,32,0,1,1,45.12,0A39.76,39.76,0,0,1,135.75,166ZM96,136a16,16,0,1,0-16-16A16,16,0,0,0,96,136Z"></path>
            </svg>
            <p className="text-sm font-light">{customer.name}</p>
          </div>
          <div className="flex items-start gap-1.5">
            <img src={EmailIcon} className="size-5 opacity-70" />
            <p className="text-sm font-light">{customer.email}</p>
          </div>
          {customer.phone ? (
            <div className="flex items-start gap-1.5">
              <img src={PhoneIcon} className="size-5 opacity-70" />
              <p className="text-sm font-light">{customer.phone}</p>
            </div>
          ) : null}
          <div className="flex items-start gap-1.5">
            <img src={LocationIcon} className="size-5 opacity-70" />
            <div>
              <p className="mr-1 inline text-sm font-light">
                {customer.address.addressLine1}
                {customer.address.addressLine2
                  ? ', ' + customer.address.addressLine2
                  : null}
              </p>
              <p className="mr-1 inline text-sm font-light">
                {customer.address.city ? ', ' + customer.address.city : null}
                {customer.address.zip ? ', ' + customer.address.zip : null}
                {country ? ', ' + country : null}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default CustomerInformation
